module.exports = __webpack_public_path__ + "media/newstyle/images/img2-footer-aus-d1a3c39a286e77d50450d90b4d4010e8.svg";